const stripeConnectInstances = new Map()

export function registerStripeConnectInstance(key, stripeConnectInstance) {
  stripeConnectInstances.set(key, stripeConnectInstance)

  return stripeConnectInstance
}

export async function logoutStripeConnectInstances() {
  const instances = [...stripeConnectInstances.values()]
  stripeConnectInstances.clear()

  const results = await Promise.allSettled(instances.map(stripeConnectInstance => Promise.resolve().then(() => stripeConnectInstance.logout())))

  results.forEach(result => {
    if (result.status === 'rejected') {
      console.error('Unable to clear a Stripe Connect session.', result.reason)
    }
  })
}
